import api from "../api";

export const useProfileDataKyc = (data) =>
    api.post('/dataspike-kyc?check_required', data).then((res) => res.data);
